var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { NavLink } from "react-router";
import { SignOutIcon } from '@phosphor-icons/react';
import { Stack, Tooltip, UnstyledButton } from '@mantine/core';
import classes from '../../styles/Navbar.module.css';
function NavbarLink(_a) {
    var Icon = _a.icon, label = _a.label, active = _a.active, to = _a.to;
    return (_jsx(Tooltip, { label: label, position: "right", transitionProps: { duration: 0 }, children: _jsx(UnstyledButton, { className: classes.link, "data-active": active || undefined, "aria-label": label, component: NavLink, to: to, style: active ? { backgroundColor: 'var(--mantine-color-white)', color: 'var(--mantine-color-blue-filled)' } : {}, children: _jsx(Icon, { size: 20 }) }) }));
}
export function Navbar(_a) {
    var navLinks = _a.navLinks, onLogout = _a.onLogout;
    var _b = useState(0), active = _b[0], setActive = _b[1];
    var links = navLinks.map(function (link, index) { return (_createElement(NavbarLink, __assign({}, link, { key: link.label }))); });
    return (_jsxs("nav", { className: classes.navbar, children: [_jsx("div", { className: classes.navbarMain, children: _jsx(Stack, { justify: "center", gap: 0, children: links }) }), _jsx(Stack, { justify: "center", gap: 0, children: _jsx(Tooltip, { label: "Log Out", position: "right", transitionProps: { duration: 0 }, children: _jsx(UnstyledButton, { className: classes.link, "data-active": active || undefined, "aria-label": "Log Out", style: active ? { backgroundColor: 'var(--mantine-color-white)', color: 'var(--mantine-color-blue-filled)' } : {}, onClick: onLogout, children: _jsx(SignOutIcon, { size: 20 }) }) }) })] }));
}
